export default __webpack_public_path__ + "static/mobile-bg-powered-022d532a50ec28a2c71b77e39031d9cc.png";